import { render, staticRenderFns } from "./ListBnDevisVal.vue?vue&type=template&id=4e845732&scoped=true&"
import script from "./ListBnDevisVal.vue?vue&type=script&lang=js&"
export * from "./ListBnDevisVal.vue?vue&type=script&lang=js&"
import style0 from "./ListBnDevisVal.vue?vue&type=style&index=0&id=4e845732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e845732",
  null
  
)

export default component.exports